module.exports = __webpack_public_path__ + "static/media/background-right-desktop.4ab3fe57.svg";